export type ValidationErrorType =
  | "REQUIRED"
  | "MIN"
  | "MAX"
  | "MIN-AND-MAX"
  | "SELECT-EXACT"
  | "TOO-LONG"
  | "INVALID-HEX"
  | "ACCESSIBILITY-ISSUE"
  | "NON-UNIQUE_APP_LEVEL_OVERRIDE"
  | "NUMBER-MISMATCH"
  | "ATLEAST-ONE-SECTION"
  | "ILLEGAL-CHARACTER"
  | "CUSTOM-TEXT-REQUIRED"
  | "INVALID-DATE"
  | "TASKS-REMAIN-OPEN"
  | "FAILED-TASK-RESTRICTIONS"
  | "FAILED-ENFORCED-TASK-COMMENT"
  | "TASK-REQUIRES-REVIEW-FORM-RESPONSE"
  | "CUSTOM-TEXT-FOR-SELECTED-OPTION-REQUIRED"
  | "OVERDUE-TASKS"
  | "EXPECTED-SUBMIT-VALUE-NOT-SET"
  | "CUSTOM";

export interface ValidationError {
  errorType: ValidationErrorType;
  subType?: undefined | "Goals";
  min?: number | undefined;
  max?: number | undefined;
  current?: number | undefined;
  expectedValue?: ExpectedValueValidationTokenDetails | undefined;
  customMessage?: string | undefined;
  /** For FAILED-TASK-RESTRICTIONS errors, contains all task restriction-related error details */
  taskRestriction?: TaskRestrictionErrorDetails | undefined;
}

export class ValidationResult {
  constructor(isValid: boolean, errors: Array<ValidationError> = []) {
    this.isValid = isValid;
    this.errors = errors;
  }

  isValid: boolean;
  errors: Array<ValidationError>;
}

export interface ExpectedValueValidationTokenDetails {
  translate: boolean;
  value: string;
}

export interface TaskRestrictionErrorDetails {
  /** The specific reason why the restriction failed */
  failureReason:
    | "NO-TASKS"
    | "BELOW-MIN-OVERALL"
    | "ABOVE-MAX-OVERALL"
    | "BELOW-MIN-CATEGORY"
    | "ABOVE-MAX-CATEGORY";
  /** For category-specific failures, this contains the category name translation key */
  failingCategoryName?: string | undefined;
  /** For category-specific failures, this contains the category's minimum task count (overrides top-level min) */
  categoryMin?: number | undefined;
  /** For category-specific failures, this contains the category's maximum task count (overrides top-level max) */
  categoryMax?: number | undefined;
  /** The task type plural name translation key identifier for replacing #TASK_TYPE# token */
  taskTypeTranslationKeyIdentifier?: string | undefined;
  /** The task type singular name translation key identifier for replacing #TASK_TYPE# token when count is 1 */
  taskTypeSingularTranslationKeyIdentifier?: string | undefined;
}

export default ValidationResult;
